import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';

var useWindowWidth = function useWindowWidth() {
  var _useState = useState(typeof window !== 'undefined' ? window.innerWidth : 0),
      _useState2 = _slicedToArray(_useState, 2),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  var handleResize = function handleResize() {
    return setWindowWidth(window.innerWidth);
  };

  useEffect(function () {
    if (typeof window !== 'undefined') {
      setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);
  return windowWidth;
};

export default useWindowWidth;